/**
 * Shared UI component for UI Badge.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, input } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';
import { UiBadgeTone } from './ui-badge.types';

@Component({
  selector: 'ui-badge',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-badge.component.html',
  styleUrl: './ui-badge.component.scss'
})
export class UiBadgeComponent {
  readonly label = input('');
  readonly tone = input<UiBadgeTone>('active');
}
